<section class="CommendSlider" *ngIf="items.length > 0">
	<h2 class="Heading--marginLeft">Рекомендуем</h2>

	<div class="uk-position-relative" uk-slider="finite: true">
		<div uk-grid>
			<div class="CommendSlider_Prev uk-width-1-5">
				<div class="uk-width-1-1 uk-height-1-1 uk-position-relative">
					<a class="SliderArrow SliderArrow--left uk-position-top-left" href="#" uk-slider-item="previous">
						<span class="IconItem IconItem--arrowLeft">
							<img src="/assets/img/icon/arrow-left.svg" uk-svg>
						</span>
					</a>
				</div>
			</div>

			<div class="CommendSlider_Container uk-width-3-5">
				<div class="uk-slider-container">
					<ul class="uk-slider-items uk-child-width-1-4@l">
						<li *ngFor="let item of items" class="CommendSlider_Slide">
							<a class="CommendSlider_Slide_Container" [routerLink]="cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', item.CODE || item.ID]
				 	: ['/catalog', item.CODE || item.ID]">
								<span class="CommendSlider_Slide_Img uk-background-contain uk-position-relative"
									  [style.background-image]="item.PREVIEW_PICTURE ? 'url(' + item.PREVIEW_PICTURE.SRC + ')' : ''"
								>
									<span *ngIf="!item.PREVIEW_PICTURE" class="uk-position-center uk-h3 uk-margin-remove">Нет фото</span>
								</span>
								<span class="CommendSlider_Slide_Title">{{item.NAME}}</span>

								<span *ngIf="!item.OFFERS" class="CommendSlider_Slide_Price">
									<ng-template [ngIf]="item.BASE_PRICE.PRICE"><span *ngIf="item.BASE_PRICE.QUANTITY_FROM">от </span>{{item.BASE_PRICE.PRICE | currency: item.BASE_PRICE.CURRENCY : 'symbol' :'1.0-0'}}</ng-template>
			                        <ng-template [ngIf]="!item.BASE_PRICE.PRICE">Нет цены</ng-template>
								</span>

								<span *ngIf="item.OFFERS" class="CommendSlider_Slide_Price">
									<span *ngIf="item.OFFERS[0].PRICE.PRICE.QUANTITY_FROM">от </span>{{item.OFFERS[0].PRICE.RESULT_PRICE.DISCOUNT_PRICE | currency:item.OFFERS[0].PRICE.RESULT_PRICE.CURRENCY : 'symbol' : '1.0-0'}}
								</span>
							</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="CommendSlider_Next uk-width-1-5">
				<div class="uk-width-1-1 uk-height-1-1 uk-position-relative">
					<a class="SliderArrow SliderArrow--right uk-position-top-right" href="#" uk-slider-item="next">
						<span class="IconItem IconItem--arrowRight">
							<img src="/assets/img/icon/arrow-right.svg" uk-svg>
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</section>
